import i18next from 'i18next';
import { Base64 } from 'js-base64';
import _ from 'lodash';
import moment from "moment-timezone";
import cookie from "react-cookies";
import {EVENT} from '../common/events/listEvents';
import { } from '../common/Extensions';
import { BetTypeGroup, LoginStatus, Market, MarketFilter, MOBILE_VIEWS, PrefsMap, TIER } from "../common/Foundation";
import SameSite from '../common/SameSite';
import Utils from "../common/Utils";
import AlertComponentAction from '../components/BaseComponent/AlertComponent/AlertComponentAction';
import memberServices from "../services/MemberService";
import $ from 'jquery';
import Constants from '../common/Constants'


export default class AccountAction {
    static LOGIN_SUCCESS = [LoginStatus.SUCCESS_WITH_STT_1, LoginStatus.SUCCESS_WITH_STT_3, LoginStatus.SUCCESS_WITH_STT_6]
    static fireEventReloadAccountBalance() {
        window.fireEvent(EVENT.ACCOUNT_BALANCE_RELOAD);
    }

    static async getQuickStakeData(AccountStore) {
        try {
            const response = await memberServices.getQuickStakeInfor();
            if(response.data) {
                const stakeDefault = !!response.data.stakeDefault
                    ? response.data.stakeDefault.split(":").map((stake) => Number(stake))
                    : [0, 0, 0, 0]
                const stakeValue = !!response.data.stakeValue
                    ? response.data.stakeValue.split(",").map((stake) => Number(stake))
                    : stakeDefault
                const quickStakeData = {
                    ...response.data,
                    stakeDefault,
                    stakeValue
                };
                AccountStore.setQuickStakeData(quickStakeData)
            }
        }
        catch (err) {
            console.log(err)
        }
    }

    static async signin(loginId, password, captcha = "", captchaToken = "") {
        try {
            let response = await memberServices.postLoginAPI(loginId, password, captcha, captchaToken);
            response.loginId = loginId;
            return this.convertToResultLogin(response)
           
        } catch (e) {
            let resultLogin = {
                auth: false,
                options: null,
                message: ''
            }
            resultLogin.message = i18next.t('errors:ERROR_SERVICE', {
                0: 'login'
            })
            // console.log("Error Sigin:", e)
            return resultLogin
        }
    }

    static async actionAfterLoginResult(resultLogin, gotoDefaultPage, asiaMobileURL) {
		await memberServices.getDataNoCacheAPI().then(res => {
        if (resultLogin != null) {
            if (resultLogin.auth) {
                this.setInfoAfterLogin();
                // Initialize closeAnnTime value when users logged
                cookie.save('closeAnnTime', 0, {path: '/'});
                  const __udata = AccountAction.splitDataNoCache(res.data);
                  const loginId = __udata ? __udata.loginId : "";
                  const callbackOptions = {
                    isShowPopUp: false,
                    defaultMobileView: __udata.defaultMobileView,
                    locale: __udata.locale
                  };

                  this.initSessionCookies(resultLogin.status, loginId);
                if (resultLogin.status == LoginStatus.SUCCESS_WITH_STT_2 || resultLogin.status == LoginStatus.NO_SECURITY_QA) {
                    localStorage.setItem('_needToChangePW', true);
                    //change password go to Asia Page
                    setTimeout(this.gotoAsiaChangePassPage, 800, asiaMobileURL);
                    return
                } else if (resultLogin.status == LoginStatus.SUCCESS_AFTER_MULTI_FAIL) {
                    if (resultLogin.statusMultiFail === LoginStatus.SUCCESS_WITH_STT_2) {
                        localStorage.setItem('_needToChangePW', true);
                        AlertComponentAction.openAlert(resultLogin.message, '', false, () => this.gotoAsiaChangePassPage());
                        return
                    } else {
                        AlertComponentAction.openAlertCallBack(resultLogin.message, () => { gotoDefaultPage(callbackOptions) });
                    }
                } else if (resultLogin.status == LoginStatus.SUCCESS_WITH_STT_3) {
                    this.clearCookieAcceptTC(true);
                    setTimeout(gotoDefaultPage, 800, callbackOptions);
                    // window.fireEvent(EVENT.FIRST_LOGIN);
                    
                } else {
                    setTimeout(gotoDefaultPage, 800, callbackOptions);
                    window.fireEvent(EVENT.REFRESH_DATA);
                }
                window.fireEvent(EVENT.GET_DATA_NOCACHE);
            } else {
                AlertComponentAction.openAlert(resultLogin.message);
            }
        }
	})    
}

    static initSessionCookies = (loginStatus, loginId) => {
      const sameSite = (
        window.location.protocol === 'https:'
        && SameSite.isSameSiteCompatible()
      ) 
        ? "; SameSite=None; Secure" 
        : "";

      if (loginStatus) {
        document.cookie = "rs="+loginStatus+";domain="+AccountAction.getSubDomain()+";path=/" + sameSite;  
      }
      const userId = loginId ? Base64.encode(loginId) : "";
      document.cookie = "_loginId=" + userId + ";domain="+AccountAction.getSubDomain()+";path=/" + sameSite;
      const sessionString = '{%22userName%22:%22'+loginId+'%22%2C%22id%22:%22'+loginId+'%22%2C%22role%22:{%22bitMask%22:2%2C%22title%22:%22user%22}}';
      document.cookie = "session=" + sessionString + ";domain="+AccountAction.getSubDomain()+";path=/" + sameSite;
    }

    static gotoAsiaChangePassPage(){
        const path = '/m/' + Utils.getCurrentLang() + '/asian/change-password'
        const rtBack = '?toLogin&rtback=' + encodeURIComponent('/m/' + Utils.getUserLanguage())
        let hrefURL = MOBILE_VIEWS.ASIA === Utils.getViewByURLPath() ? path : `${path}${rtBack}`;
        window.location.href = hrefURL
    }

    static gotoBlockPage(){
        const blockPageUrl = `/${Utils.getCurrentLang()}/block-page`;
        window.location.href = blockPageUrl;
    }

    static clearCookieAcceptTC(saveCookie = true) {
        cookie.remove('isShowAcceptTC', {path: '/'})
        cookie.remove('isShowAcceptTC', {path: '/', domain: AccountAction.getSubDomain()})
        if(saveCookie) {
            Utils.saveCookie("isShowAcceptTC", true, {path: "/", domain: AccountAction.getSubDomain()});
        }
        // For Mobile OLD version
        Utils.setShowTCPageST(saveCookie);
    }

    static convertToResultLogin(response) {
        let resultLogin = {
            auth: false,
            options: null,
            message: '',
            status: LoginStatus.INVALID_USER_OR_PASS
        }
        if (response.data == LoginStatus.SUCCESS_WITH_STT_1 || response.data == LoginStatus.SUCCESS_WITH_STT_6) {
            resultLogin.message = i18next.t('errors:SUCCESS_LOGIN');
            resultLogin.status = response.data;
            resultLogin.auth = true;
            return resultLogin
        }

       

        if (response.data == LoginStatus.SUCCESS_WITH_STT_3) {
            // resultLogin.message = 'Please check your odds format setting'
            resultLogin.message = i18next.t('errors:SHOW_TERM_CODITION');
            resultLogin.status = response.data;
            resultLogin.auth = true;
            return resultLogin
        }

         if (response.data == LoginStatus.SUCCESS_WITH_STT_2 || response.data == LoginStatus.NO_SECURITY_QA) {
            // resultLogin.message = 'Please check your odds format setting'
            resultLogin.message = i18next.t('errors:HAVE_TO_CHANGEPASSWORD');
            resultLogin.status = response.data;
            resultLogin.auth = true;
            resultLogin.loginId = response.loginId;
            return resultLogin
        }

        if (response.data == LoginStatus.INVALID_CAPTCHA) {
          resultLogin.message = i18next.t('errors:INVALID_CAPTCHA')
          resultLogin.status = response.data;
          return resultLogin
        }
        
        if (response.data == LoginStatus.INVALID_TRUSTCODE) {
          resultLogin.message = i18next.t('errors:INVALID_LOGINID_PASSWORD');
          resultLogin.status = response.data;
          return resultLogin
        }

        if (response.data == LoginStatus.BLOCKED_IP_RING_FENCING) {
            resultLogin.status = response.data;
            return resultLogin
        }

        if (response.data == LoginStatus.INVALID_USER_OR_PASS) {
            // resultLogin.message = 'Please enter a valid login name and password.'
            resultLogin.message = i18next.t('errors:INVALID_LOGINID_PASSWORD');
            resultLogin.status = response.data;
            return resultLogin
        }
        if (response.data == LoginStatus.LOGIN_FAILED) {
            // resultLogin.message = 'Login failed. Please contact Customer Service Support.'
            resultLogin.message = i18next.t('errors:ERROR_LOGIN_FAILED');
            resultLogin.status = response.data;
            return resultLogin
        }
        if (response.data == LoginStatus.WRONG_COUNTRY) {
            // resultLogin.message = 'Your current IP address does not match your registration country.'
            resultLogin.message = i18next.t('errors:INVALID_CURRENT_IP');
           resultLogin.status = response.data;
            return resultLogin
        }
        if (response.data == LoginStatus.ACCOUNT_UNVERIFIED) {
            // resultLogin.message = 'Your account is unverified.'
            resultLogin.message = i18next.t('errors:ERROR_VERIFIED_ACCOUNT');
            resultLogin.status = response.data;
            return resultLogin
        }
        if (response.data == LoginStatus.WRONG_ODDS_FORMAT) {
            // resultLogin.message = 'Please check your odds format setting'
            resultLogin.message = i18next.t('errors:INVALID_ODD_FORMAT');
            resultLogin.status = response.data;
            return resultLogin
        }

        if (!_.isNil(response.data) && !_.isNil(response.data.error)) {
            if(response.data.error === LoginStatus.SELF_EXCLUSION) {
                if(moment(response.data.expire).diff(moment(), 'days') > 90){
                    resultLogin.message = i18next.t('errors:SELF_EXCLUSION')
                } else {
                    let dateTime = moment(response.data.expire).format('ddd, MMM DD YYYY HH:mm A')
                    resultLogin.message = i18next.t('errors:M004', {0: dateTime})
                }
                return resultLogin
            }
        }        

        if (!_.isNil(response.data) && !_.isNil(response.data.code)) {
            if (response.data.code == LoginStatus.ACCOUNT_SUSPENDED) {
                let message = response.data.userType == 'cash'
                    // ? 'Account suspended due to too many failed login attempts. Please contact Customer Service for assistance.'
                    // : 'Account suspended due to too many failed login attempts. Please contact your upline.'
                    ?
                    i18next.t('errors:ERROR_LOGIN_MUCH_TIME_CASH') :
                    i18next.t('errors:ERROR_LOGIN_MUCH_TIME_CREDIT');
                resultLogin.message = message;
                resultLogin.status = LoginStatus.ACCOUNT_SUSPENDED;
                return resultLogin
            }
            if(response.data.code == LoginStatus.TRY_IN_FEW_MINS){
                let message = (response.data.userType).toLowerCase() == 'cash'
                    ?  i18next.t('errors:ERROR_LIMIT_LOGIN_FAILED_FEW_MIN_CASH')
                    : i18next.t('errors:ERROR_LIMIT_LOGIN_FAILED_FEW_MIN_CREDIT')
                resultLogin.message = message;
                return resultLogin;
            }
            if (response.data.code == LoginStatus.TRY_IN_20_MINS ) {
                let message = (response.data.userType).toLowerCase() == 'cash'
                    ?  i18next.t('errors:ERROR_LIMIT_LOGIN_FAILED_20_MIN_CASH')
                    : i18next.t('errors:ERROR_LIMIT_LOGIN_FAILED_20_MIN_CREDIT')
                resultLogin.message = message;
                return resultLogin;
            }
            if(response.data.code == LoginStatus.ACCOUNT_MIGRATED_TO_PS3838) {
                resultLogin.message = i18next.t('errors:ERROR_ACCOUNT_MIGRATION', {0: response.data.url, 1: response.data.url});
                resultLogin.status = response.data.code;
                localStorage.setItem("urlMigration",  response.data.url);
                return resultLogin;
            }
        }

        let result = response.data.split('\n')
        if (!_.isNil(result) && result.length > 1) {
            if (!_.isNil(result[3])) {
                let dateTime = moment(new window.DateTZ(window.parseInt(result[2]))).format('ddd, MMM DD YYYY HH:mm [GMT]Z')
                let msg = i18next.t('errors:SUCCESS_LOGIN_AFTER_FAILED', {
                    0: result[0],
                    1: result[1],
                    2: dateTime
                })
                // let msg = result[0] + ' unsuccessful login attempt(s)! The last unsuccessful attempt was from IP address ' + result[1] + ' on ' + dateTime
                resultLogin.message = msg;
                resultLogin.status = LoginStatus.SUCCESS_AFTER_MULTI_FAIL;
                resultLogin.auth = true;
                resultLogin.statusMultiFail = parseInt(result[3])
                return resultLogin;
            } 
        }

        return resultLogin;
    }

    static async logout() {
      try {
        this.clearSession(); 
        const res = await memberServices.postLogoutAPI();
        if(res && res.data) {
            this.cleanUp();
        }
        return res
      } catch (err) {
        this.cleanUp();
        return
      }
    }

    static async checkLogout() { // Check case update URL + Enter without change password
        if(!this.isAuth()) return
        const needToChangePW = localStorage.getItem('_needToChangePW')
		if (needToChangePW && !this.isChangePasswordPage()) {
			return await this.logout()
		}
        return
    }

    static cleanUp() {
      this.clearDataOnBrowser();
      AccountAction.clearCookieAcceptTC(false);
      this.redirect()
    }

    static getArcadiaURL (domain, pathname){
      const returnURL = encodeURIComponent(`${window.location.origin}${pathname}`);
      return `${domain.replace("/{locale}", "")}/${Utils.getCurrentLang()}/?isLogout=true&returnUrl=${returnURL}`
    }
    
    static checkGDPRForm(layoutTemplateStore) {
      const templateData = layoutTemplateStore.templateData;
      const currentViewContainer = layoutTemplateStore.currentViewContainer;
      const footerContainer = _.get(templateData, 'footerContainer', {});
      if (footerContainer[currentViewContainer]) {
        return footerContainer[currentViewContainer].filter(f => f.componentName === "MbGDPRModalComponent").length > 0;
      } else if (footerContainer['formal']) {
        return footerContainer['formal'].filter(f => f.componentName === "MbGDPRModalComponent").length > 0;
      }
      return false;
    }

    static async getDataNoCache(templateName, layoutTemplateStore) {
        return memberServices.getDataNoCacheAPI().then(res => {
            if (!res.data.includes("__udata")) {
              const script = `<script type="text/javascript">${res.data}</script>`;
              const range = document.createRange();
              document.body.appendChild(range.createContextualFragment(script));
              return;
            }
            let user = {};
            let __udata = AccountAction.splitDataNoCache(res.data);
            window.wagerMode = __udata.wagerMode;
            __udata.userIp = Utils.getRealIP(__udata, res);

            // white label and pa will use new GDPR form. The old tnc form is only use for iframe
            //const templateData = layoutTemplateStore.templateData;
            //const isIframe = templateData.templateType === Constants.TEMPLATE_TYPE.IFRAME;
            //const isExistingGdprForm = !isIframe 
            //  ? this.checkGDPRForm(layoutTemplateStore)
            //  : false;
            const templateData = layoutTemplateStore.templateData;
            const isIframe = templateData.templateType === Constants.TEMPLATE_TYPE.IFRAME;
            const isExistingGdprForm = !isIframe 
              ? templateData.footerContainer.asiaView.filter(f => f.componentName === "MbGDPRModalComponent").length > 0 
              : false;

            // Set tncEnabled to cookie
            const tncEnabled = __udata && __udata.auth 
              ? (isIframe ? false: (isExistingGdprForm ? false : __udata.tncEnabled)) // if the new GDPR form is not exist then will use old tnc form
              : false; 
            Utils.saveCookie("isShowAcceptTC", tncEnabled, {path: "/", domain: AccountAction.getSubDomain()});

            // For Mobile OLD version
            Utils.setShowTCPageST(tncEnabled);

            localStorage.setItem('__udata', window.btoa(unescape(encodeURIComponent(JSON.stringify(__udata)))))
            Utils.saveCookie('skin', __udata.skin, {
                path: "/",
                domain: AccountAction.getSubDomain()
            })
            let modeDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

            if (modeDev) {
                Utils.saveCookie('skin', templateName, {
                    path: "/",
                    domain: AccountAction.getSubDomain()
                });
            }

            Utils.saveCookie('locale', __udata.locale, {
                path: "/",
                domain: AccountAction.getSubDomain()
            })
            AccountAction.setUserIP(__udata.userIp);
            const enableMaintenance = _.get(__udata, 'enableMaintenance', false);
            if (__udata.auth) {
               user = {
                    'auth': true,
                    'loginId': __udata.loginId,
                    'freshId': __udata.freshId,
                    'email': __udata.email,
                    'fullName': __udata.fullName,
                    'mode': __udata.mode,
                    'currency': __udata.currency,
                    'currencyUnit': __udata.currencyUnit,
                    'maxBetPreferenceSettingBase': __udata.maxBetPreferenceSettingBase,
                    'token': __udata.token,
                    'isMultipleBets': __udata.isEnableMultiBet,
                    'type': __udata.type,
                    'locale': __udata.locale,
                    'skin': modeDev ? templateName : __udata.skin,
                    'defaultView': __udata.view,
                    'isBlockedCasino': __udata.isBlockedCasino,
                    'status': __udata.status,
                    'productStatus': __udata.productStatus,
                    'oddsFormatSetting': __udata.oddsFormatSetting,
                    'currentIP': __udata.userIp,
                    'country': __udata.country,
                    'enableMaintenance': enableMaintenance,
                    'tier': TIER[__udata.tier],
                    'blockedSports': __udata.blockedSports
                }
                Utils.saveCookie('auth', 'true', {
                    path: "/",
                    domain: AccountAction.getSubDomain()
                })
            } else {
                user = {
                    'auth': false,
                    'loginId': __udata.loginId,
                    'freshId': __udata.freshId,
                    'email': __udata.email,
                    'fullName': __udata.fullName,
                    'country': __udata.country,
                    'status': __udata.productStatus,
                    'productStatus': __udata.productStatus,
                    'enableMaintenance': enableMaintenance
                };
                user.sportSuppLS = __udata.sportSuppLS;
                Utils.saveCookie('auth', 'false', {
                  path: "/",
                  domain: AccountAction.getSubDomain()
                })
              }
            user.liveBlockedSports = __udata.liveBlockedSports;
            user.liveBlockedLeagues = __udata.liveBlockedLeagues;
            Utils.setCookieDomain();
            return user;
        })
    }

    static setInfoAfterLogin() {
        let options = {}
        options.ogCache = cookie.load('_og') || ""
        let __prefs = Utils.decodeBase64(cookie.load('__prefs'))
        let __prefsJSON = Utils.convertStringToJSON(__prefs)
        let perfs = localStorage.getItem('perfs') || null
        let oldPrefs = _.isEmpty(perfs) ? {} : atob(perfs)

        options.timeZoneOffset = __prefsJSON[PrefsMap.timeZoneOffset] === null ? moment().utcOffset : __prefsJSON[PrefsMap.timeZoneOffset]
        options.oddsFormat = __prefsJSON[PrefsMap.oddsFormat]
        options.oddsMode = __prefsJSON[PrefsMap.oddsMode]
        options.market = __prefsJSON[PrefsMap.market] === 0 ? Market.Today : Market.All
        options.betTypeGroup = __prefsJSON[PrefsMap.market] === 0 ? BetTypeGroup.HDP_OU : (__prefsJSON[PrefsMap.market] === 1 ? BetTypeGroup.ML_1X2 : BetTypeGroup.TEAM_TOTAL)
        options.order = __prefsJSON[PrefsMap.order]
        options.sportsSorting = __prefsJSON[PrefsMap.sportsSorting] && ("," + __prefsJSON[PrefsMap.sportsSorting] + ",")
        options.enableDefaultStake = __prefsJSON[PrefsMap.enableDefaultStake]
        options.defaultStake = __prefsJSON[PrefsMap.defaultStake]
        options.acceptBetterOdds = __prefsJSON[PrefsMap.acceptBetterOdds]
        options.updateBetslipOdds = __prefsJSON[PrefsMap.updateBetslipOdds]
        options.marketFilter = this.castToMarketFilter(__prefsJSON[PrefsMap.marketFilter]) || 5
        options.liveScoreNotify = __prefsJSON.length >= 12 ? __prefsJSON[PrefsMap.liveScoreNotify] : 0
        options.favouriteEventIds = oldPrefs.favouriteEventIds || []
        options.sound = (typeof (oldPrefs.sound) === "undefined" || true) ? true : false
        options.favourite = oldPrefs.favourite || false
        options.favouriteSportId = oldPrefs.favouriteSportId || 0
        options.timeFilter = oldPrefs.timeFilter || 0
        options.timeZoneId = __prefsJSON[PrefsMap.timeZoneId]
        localStorage.setItem('perfs', btoa(JSON.stringify(options)))

        if (__prefsJSON[PrefsMap.timeZoneOffset] === null) {
            __prefsJSON[PrefsMap.timeZoneOffset] = moment().utcOffset
            Utils.saveCookie('__prefs', btoa(JSON.stringify(__prefsJSON)), {
                path: "/",
                domain: AccountAction.getSubDomain()
            })
        }

        //init data for Classic View
        if (document.URL.indexOf('classic') > -1) {
            let classicOptions = {}
            classicOptions.acceptBetterOdds = __prefsJSON[PrefsMap.acceptBetterOdds]
            classicOptions.oddsFormat = __prefsJSON[PrefsMap.oddsFormat]
            let refreshData = localStorage.getItem('refresh_data') ? JSON.parse(Base64.decode(localStorage.getItem('refresh_data'))) : []
            Object.assign(refreshData, classicOptions);
            localStorage.setItem('refresh_data', Base64.encode(JSON.stringify(refreshData)))
        }
        window.fireEvent(EVENT.UPDATE_SPORTS_TORE);
        return options
    }

    static castToMarketFilter = (marketDisplayType) => {
        switch (marketDisplayType) {
            case "ALL":
                return MarketFilter.All
            case "_1LINE":
                return MarketFilter._1Line
            case "_3LINES":
                return MarketFilter._3Lines
            case "_5LINES":
                return MarketFilter._5Lines
            default:
                return MarketFilter.Error
        }
    }

    static splitDataNoCache(__udata) {
      const _UDATA = JSON.parse(__udata.replace("var __udata=", "").replaceAll(";", ""));
      _UDATA.currentView = '';
      return _UDATA;
    }

    static async accountBalance() {
        return await memberServices.postAccountBalanceAPI().then(response => {
            const result = {
                status: response.status,
                data: response.data
            }
            if (response.data) {
                if (response.data.error) {
                    if (response.data.error === 'MULTIPLE_LOGIN') {
                        Utils.isIniFrame() && window.parent.postMessage({
                            msgCode: 'lostSession',
                            msgData: true
                        }, "*");
                        return this.dataObjectMultipleLogin(response);
                    }
                    if (response.data.msg) {
                        result.data = response.data.msg
                        return result;
                    }
                } else if (!response.data.success) {
                    if (response.data.isValidUserIPRingFencing === false && !Utils.isPA()) {
                        this.gotoBlockPage();
                    }
                }
            }
            return result;
        }).catch(error => {
            if (!error.status) {
                return {
                    status: "net::ERR_NETWORK_IO_SUSPENDED"
                }
            }
            return {
                status: error.response.status
            }
        })
    }

    static dataObjectMultipleLogin(response) {

        return {
            error: _.get(response, 'data.error', ''),
            status: response.status,
            message: i18next.t('errors:MULTIPLE_LOGIN'),
            reload: true
        }
    }

    static async getAcceptTC(isPromoEmail, version) {
        return await memberServices.getAcceptTC(isPromoEmail, version).then(response => {
            return true
        }).catch(error => {
            return false
        })
    }

    static async getVersionTNC(linkTNC) {
        return await memberServices.getVersionTNC(linkTNC).then(response => {
            try {
                return $(response.data).find('.documentation__outline:first-child tbody>tr:nth-child(2) td:last').text();
            }catch (e){
                return ""
            }
        }).catch(error => {
            return ""
        })
    }

    static getSubDomain() {
        let parts = document.domain.split('.');
        let domain = document.domain;
        if (parts.length > 2 && isNaN(parts[0])) {
            parts.splice(0, parts.length - 2);
            domain = "." + parts.join(".");
        }
        return domain
    }

    static clearDataOnBrowser() {
        if (localStorage.getItem('__udata') != null) {
          const __udata = JSON.parse(window.atob(localStorage.getItem('__udata')));
          document.body.classList.remove(__udata.type);
          document.documentElement.classList.remove(__udata.type);
          __udata.auth = false;
          localStorage.setItem('__udata', window.btoa(JSON.stringify(__udata)));
        }
       
        sessionStorage.removeItem('perfs');
        localStorage.removeItem('perfs');
        localStorage.removeItem('defaultView');
        localStorage.removeItem('_needToChangePW');  
        window.fireEvent(EVENT.USER_LOG_OUT);
    }

    static setUserIP(userIp) {
        let localUserIp = window.atob(localStorage.getItem('rip')) || null
        if (typeof localUserIp === 'undefined' || localUserIp === null || localUserIp !== userIp) {
            localStorage.setItem('rip', window.btoa(userIp))
        }
    }

    static openNewBetslipMobileNotify() {
        const needToChangePW = localStorage.getItem('_needToChangePW')
        const __udata = Utils.getUdata()
        const isShowAcceptTC = JSON.parse(cookie.load('isShowAcceptTC') || 'false')
        if(!this.isAuth() || needToChangePW || isShowAcceptTC || !window.env.enableNewBetslip) return
        if (__udata.newBetslipPopupEnabled && !Utils.isArcadia()) {
            AlertComponentAction.openAlertCallBack(
                i18next.t("NEW_MOBILE_BETSLIP_NOTIFY"),
                AccountAction.acceptNewBetslipMobileNotify,
                "alert_bet_confirmation new_bet_modal",
                i18next.t("New Bet Slip on Mobile")
            );
        }
    }

    static async acceptNewBetslipMobileNotify() {
        try {
            const response = await memberServices.acceptNewBetslipMobileNotify();
            if(!response.data) {
                AccountAction.openNewBetslipMobileNotify()
            }
        }
        catch (err) {
            console.log(err)
        }
    }

    static notifyLiveScore() {
        let auth = this.isAuth();
        let perfs = null
        try {
            perfs = JSON.parse(window.atob(localStorage.getItem('perfs')))
        } finally {
            if (typeof perfs === 'undefined' || perfs === null) {
                return {
                    showPopup: false,
                    message: ''
                }
            }
        }

        let liveScoreNotify = perfs.hasOwnProperty('liveScoreNotify') ? perfs.liveScoreNotify : null
        if (auth && (typeof (liveScoreNotify) === "undefined" || liveScoreNotify === null)) {
            this.setInfoAfterLogin()
            liveScoreNotify = perfs.liveScoreNotify
        }
        let isRemindLater = perfs.hasOwnProperty('isRemindLater') ? perfs.isRemindLater : 0
        if (liveScoreNotify < 0 && auth && !isRemindLater) {
            return {
                showPopup: true,
                message: 'New feature Live Score Announcement is now avaiable.<br>Do you want to enable this feature for your conveniences?'
            }
        }
        return {
            showPopup: false,
            message: ''
        }
    }

    static updateNotifyLiveScore(accept) {
        let perfs = null
        try {
            perfs = JSON.parse(window.atob(localStorage.getItem('perfs')))
        } finally {
            if (typeof perfs === 'undefined' || perfs === null) {
                return
            }
        }
        if (accept === -1) {
            perfs.isRemindLater = 1
            localStorage.setItem('perfs', window.btoa(JSON.stringify(perfs)))
            window.location.href = window.location.href
        }
        perfs.liveScoreNotify = accept
    }

    static redirect() {
        if (_.get(window, 'env.isBrandEnableLogoutOnArcadia')) {
            const pathname = `/m/${Utils.getCurrentLang()}/asian`;
            window.location.href = this.getArcadiaURL(window.env.futureViewURL || window.env.fvURL || window.location.href, pathname);
        } else {
            window.location.reload();
        }
    }
    static handleMultipleLogin() {
        AccountAction.logout()
    }

    static reloadAccountBalance(AccountStore) {
        const needToChangePW = localStorage.getItem("_needToChangePW");  
        if (!needToChangePW) {
            return AccountAction.accountBalance().then(response => {
                if (response.status === 200) {
                    if (response.error) {
                        if (response.error === 'MULTIPLE_LOGIN') {
                            AccountStore.resetUser();
                            AlertComponentAction.openAlert(response.message, '', false, () => AccountAction.logout());
                            return;
                        }
                        AlertComponentAction.openAlert(response.message);
                        this.clearDataOnBrowser();
                    }
                    if (!response.data.success && response.data.isExceedSessionLimit) {
                        return response.data;
                    }
                    if (response.message) {
                        AccountStore.updateStatus(response)
                        return
                    }
                    const isAuth = !_.isNil(response.data.loginId);
                    const totalMessage = _.get(response, 'data.totalMessage', 0);
                    const __prefs = _.isEmpty(localStorage.getItem('perfs')) ? '' : Utils.decodeBase64(localStorage.getItem('perfs'));
                    const __prefsJSON = _.isEmpty(__prefs) ? {} : Utils.convertStringToJSON(__prefs);
                    AccountStore.updateUser({
                        'auth': isAuth,
                        'loginId': response.data.loginId,
                        'currency': response.data.currency,
                        'betCredit': Utils.formatBalance(response.data.betCredit),
                        'outstanding': Utils.formatBalance(response.data.outstanding),
                        'message': response.data.totalMessage,
                        'sumAnnouncement': response.data.sumAnnouncement,
                        'isRefresh': true,
                        'tier': TIER[response.data.currentTierId],
                        'hasLoginMessage': response.data.hasLoginMessage,
                        'betTypeGroup': __prefsJSON.betTypeGroup ? __prefsJSON.betTypeGroup : BetTypeGroup.HDP_OU
                    })
                    let __udata = Utils.getUdata() || null
                    if (__udata.currentTierId !== response.data.currentTierId) {
                        const newUdata = { ...__udata, currentTierId: response.data.currentTierId }
                        localStorage.setItem('__udata', window.btoa(JSON.stringify(newUdata)))
                    }
                    window.fireEvent(EVENT.REFRESH)
                    if (_.isNil(response.data.loginId)) {
                        AccountAction.clearDataOnBrowser();
                    }
                    const isCreditUser = AccountStore.isCreditUser;
                    let displayMessPopUp = cookie.load('displayMessPopUp') || false;
                      if (isAuth &&  !displayMessPopUp && isCreditUser) {
                        if (totalMessage > 0) {
                          AccountStore.updateIsOpenMessagePopup(true);
                        }
                        Utils.saveCookie("displayMessPopUp", true, {path: "/", domain: AccountAction.getSubDomain()});
                    }
                    return response.data;
                  }
            });
        }
        else return Promise.resolve({});
    }

    static isAuth(){
        
        if(typeof(cookie.load('auth')) !== 'undefined' && cookie.load('auth') != null){
             let auth = cookie.load('auth') === 'true';
             return auth
        }
        else{
             return false;
        }
        
    }

  static clearSession() {
    // remove all the cookies which are added by client
    const cookies = cookie.loadAll();
    const dynamicParamCookie = localStorage.getItem("_dp") || ''
    Object.keys(cookies).forEach(cookieName => {
        if (cookieName !== dynamicParamCookie) {
            cookie.remove(cookieName, { path: '/' });
            cookie.remove(cookieName, { path: '/', domain: Utils.getSubDomain() });
        }
    })
  }

	static isChangePasswordPage (){
    return window.location.href.includes("change-password");
  }

  static updateDefaultView(view){
    memberServices.updateDefaultView(view).then(res => {
        if (res){
            // CommonUtil.saveUserData('view', view);
        }
    });
  }

   /**
     * load capcha image
     * 
     * @param {*} moduleName 
     */
    static async loadCaptchaImage(moduleName) {
      return await memberServices.getCaptchaImage(moduleName).then(response => {
          if (response.data) {
              return response.data
          }
          return null
      }).catch(error => {
          console.log("Load Captchar error: ", error)
          return null
      })
    }

    static checkTrustCodeExisted(loginId) {
      const trustCodeStorage = localStorage.getItem("trustCode");
      const trustCodes = JSON.parse(trustCodeStorage);
      return this.checkLoginTrustCodeExisted(loginId, trustCodes);
    }

    static addTrustCodeToLocalStorage(loginId, trustCode, trustCodeObj) {
      if (trustCode) {
        trustCodeObj[loginId] = trustCode
        localStorage.setItem("trustCode",  JSON.stringify(trustCodeObj))
      }
    }

    static checkLoginTrustCodeExisted(loginId, trustCodeObj) {
      return trustCodeObj && !_.isNil(trustCodeObj[loginId]);
    }

    static deleteLoginTrustCode(loginId) {
      const trustCodeStore = localStorage.getItem("trustCode");
      if(trustCodeStore) {
        let trustCodeObj = JSON.parse(trustCodeStore);
        if (this.checkLoginTrustCodeExisted(loginId, trustCodeObj)) {
          delete trustCodeObj[loginId];
          localStorage.setItem("trustCode",  JSON.stringify(trustCodeObj))
        }
      }
    }
   static async sendActiveEmail(params) {
     return await memberServices.getActiveLink(params).then(res => {
       return res.data;
     });
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/AccountAction.js